import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BuildingType } from '../../data';

@Component({
    selector: '[app-warehouse-roof]',
    templateUrl: './warehouse-roof.component.html',
    styleUrl: './warehouse-roof.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WarehouseRoofComponent {
  type = input<BuildingType>();
}
